import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

import useLocale from "../../hooks/useLocale";

const MonthSelect = ({ month, handleChange = () => {}, ...props }) => {
  const { t } = useLocale();
  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{t("Month")}</InputLabel>
        <Select
          labelId="month-select"
          id="month-select"
          value={month}
          label={t("Month")}
          onChange={handleChange}
          {...props}
        >
          <MenuItem value={1}>{t("January")}</MenuItem>
          <MenuItem value={2}>{t("February")}</MenuItem>
          <MenuItem value={3}>{t("March")}</MenuItem>
          <MenuItem value={4}>{t("April")}</MenuItem>
          <MenuItem value={5}>{t("May")}</MenuItem>
          <MenuItem value={6}>{t("June")}</MenuItem>
          <MenuItem value={7}>{t("July")}</MenuItem>
          <MenuItem value={8}>{t("August")}</MenuItem>
          <MenuItem value={9}>{t("September")}</MenuItem>
          <MenuItem value={10}>{t("October")}</MenuItem>
          <MenuItem value={11}>{t("November")}</MenuItem>
          <MenuItem value={12}>{t("December")}</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default MonthSelect;
